var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerHeader = void 0;
var DrawerHeader_1 = __importDefault(require("./DrawerHeader"));
exports.DrawerHeader = DrawerHeader_1.default;
exports.default = DrawerHeader_1.default;
//# sourceMappingURL=index.js.map